import { CompendiumPanel } from '@labsavvyapp/components'
import { CompendiumPanelWithType } from '../types'

/**
 * This calculates the total contract price of all tests.
 * @param panels
 * @returns number
 */
export const calculateOrdersetClientPrice = (panels: CompendiumPanel[] | CompendiumPanelWithType[]) => {
  if (!panels) {
    return 0
  }

  const retailPackagePrice = panels.map((test) => test.contract_price).reduce((sum, price) => sum + price, 0)

  return retailPackagePrice
}
